'use client';

import { Suspense, useEffect, useState } from 'react';
import { useRouter } from 'next/navigation';
import { useAuthContext } from '@/components/providers/AuthProvider';
import { getProfileOrNull, isProfileComplete } from '@/lib/profile';
import InteractiveHomeFeed from '@/components/InteractiveHomeFeed';

export default function PostsPage() {
  const router = useRouter();
  const { user, loading: authLoading } = useAuthContext();
  const [profile, setProfile] = useState<any>(null);
  const [profileLoading, setProfileLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    const userId = user?.id;

    if (!userId) {
      setProfile(null);
      setProfileLoading(false);
      return;
    }

    setProfileLoading(true);
    (async () => {
      const p = await getProfileOrNull(userId);
      if (cancelled) return;
      setProfile(p);
      setProfileLoading(false);
    })();

    return () => {
      cancelled = true;
    };
  }, [user?.id]);

  useEffect(() => {
    if (authLoading) return;
    if (!user) {
      router.replace('/login');
    }
  }, [authLoading, user, router]);

  useEffect(() => {
    if (authLoading || profileLoading || !user) return;

    if (!isProfileComplete(profile)) {
      router.replace('/onboarding');
      return;
    }

    if (profile?.role === 'scout') {
      router.replace('/scout-dashboard');
    }
  }, [authLoading, profileLoading, user, profile, router]);

  if (authLoading || profileLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-400" />
      </div>
    );
  }

  if (!user || !isProfileComplete(profile) || profile?.role === 'scout') {
    return null;
  }

  // InteractiveHomeFeed reads the ?tab=… query param via useSearchParams,
  // which Next 14 requires inside a Suspense boundary so search-param
  // hydration doesn't desync.
  return (
    <Suspense fallback={null}>
      <InteractiveHomeFeed />
    </Suspense>
  );
}

